<template>
  <nav class="navbar navbar-expand-lg navbar-fixed">
    <div class="container-fluid">
      <div class="navbar-minimize">
        <button class="btn btn-outline btn-fill btn-round btn-icon d-none d-lg-block" @click="minimizeSidebar">
          <font-awesome-icon class="fa fa5" :icon="$sidebar.isMinimized ? 'bars' : 'ellipsis-v'"/>
        </button>
      </div>
      <a class="navbar-brand">{{this.$route.name}}</a>
      <button type="button"
              class="navbar-toggler navbar-toggler-right"
              :class="{toggled: $sidebar.showSidebar}"
              aria-expanded="false"
              @click="toggleSidebar">
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
        <span class="navbar-toggler-bar burger-lines"></span>
      </button>
      <div class="collapse navbar-collapse justify-content-end">
        <!-- <ul class="nav navbar-nav mr-auto">
          <form class="navbar-form navbar-left navbar-search-form" role="search">
            <div class="input-group">
              <label for="searchInput"></label>
              <i class="nc-icon nc-zoom-split"></i>
              <input id="searchInput" type="text" value="" class="form-control" placeholder="Search...">
            </div>
          </form>
        </ul> -->
        <ul class="navbar-nav">
          <drop-down @change="dropDownOnChange" ref="notificationDropdown" class="dropdown-notifications" position="right">
            <template slot="title">
              <i class="nc-icon nc-bell-55"></i>
              <span class="notification">{{notificationList.length}}</span>
              <span class="d-lg-none">Notification</span>
            </template>
            <a v-for="(notification, index) in notificationList" :href="'#' + notification.href" :key="index" class="dropdown-item" v-b-tooltip.hover="notification.hasLongText" :title="notification.hasLongText ? notification.title : null" @click.prevent="readNotification(notification.uuid, notification.href)">
                {{notification.title}}
                <small class="time"><font-awesome-icon :icon="['far', 'clock']"/> {{notification.createdAt}}</small>
            </a>
            <a class="dropdown-item py-2 text-center" href="#" v-on:click.stop.prevent="seeAllNotification">See all notifications</a>
          </drop-down>
          <drop-down position="right">
            <i slot="title" class="nc-icon nc-bullet-list-67"></i>
            <!-- <a class="dropdown-item" href="#">
              <i class="nc-icon nc-umbrella-13"></i> Help Center
            </a> -->
            <a class="dropdown-item" href="#/profile">
              <i class="nc-icon nc-single-02"></i> Profile
            </a>
            <div class="divider"></div>
            <a href="#/logout" class="dropdown-item text-danger">
              <i class="nc-icon nc-button-power"></i> Log out
            </a>

          </drop-down>
        </ul>
      </div>
    </div>
  </nav>
</template>
<script>
  export default {
    computed: {
      routeName () {
        const {name} = this.$route
        return this.capitalizeFirstLetter(name)
      }
    },
    data () {
      return {
        notificationList: [],
        activeNotifications: false
      }
    },
    mounted () {
      this.getNotificationList()
    },
    methods: {
      capitalizeFirstLetter (string) {
        return string.charAt(0).toUpperCase() + string.slice(1)
      },
      toggleNotificationDropDown () {
        this.activeNotifications = !this.activeNotifications
      },
      closeDropDown () {
        this.activeNotifications = false
      },
      toggleSidebar () {
        this.$sidebar.displaySidebar(!this.$sidebar.showSidebar)
      },
      hideSidebar () {
        this.$sidebar.displaySidebar(false)
      },
      minimizeSidebar () {
        this.$sidebar.toggleMinimize()
      },
      readNotification (notificationUuid, url) {
        this.$emit('clickNotification', notificationUuid)
        this.$router.push(url)
      },
      seeAllNotification () {
        this.$refs.notificationDropdown.toggleDropDown()
        this.$emit('openAllNotification')
      },
      dropDownOnChange (isOpen) {
        if (isOpen) {
          this.$emit('closeAllNotification')
        } else {
          this.$emit('openAllNotification')
        }
        this.$emit('closeAllNotification')
      },
      getNotificationList () {
        this.$http.get(window.AppConfig.apiUrl + 'notification?limit=5&is_read=0')
          .then(response => {
            if (response === undefined) return false
            this.notificationList = []
            for (let i = 0; i < response.data.data.length; i++) {
              let url = null
              // if (response.data._embedded.notification[i].type === 'serviceOrder') {
              //   url = '/orders/' + response.data._embedded.notification[i].facilityBooking
              // }
              url = '/penjualan/' + response.data.data[i].order_id
              this.notificationList.push({
                uuid: response.data.data[i].id,
                title: response.data.data[i].title,
                createdAt: this.$moment(response.data.data[i].created_at).from(this.$moment().format()),
                href: url,
                unread: response.data.data[i].unread,
                hasLongText: response.data.data[i].title !== null && response.data.data[i].title.length > 0 ? response.data.data[i].title.length > 26 : 0
              })
            }
          })
          .catch(error => {
            this.$store.dispatch('notification/error', error)
          })
      }
    }
  }

</script>

<style>
  .dropdown-notifications .dropdown-menu {
    width: 250px;
  }
</style>


<style scoped>
  .fa5 {
    width: 18px !important;
  }
  .dropdown-notifications .dropdown-item {
    padding: 4px 16px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.15);
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .dropdown-notifications .dropdown-item:last-child {
    border-bottom: 0px;
  }
  .dropdown-notifications .dropdown-item small {
    width: 100%;
    display: block;
    color: #ababab;
  }
</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Layout/TopNavbar.vue